import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Checkbox from "../../../../Components/Checkbox/Checkbox";
import {
  unRegisterCarrierShift,
  updateShiftsInCity,
} from "../../../../Store/Reducers/Settings/actions";
import _ from "lodash";

export default function SingleShift({ single_shift, date, updateShift }) {
  const dispatch = useDispatch();
  const [shift, setShift] = useState(single_shift);

  const [end_time, setEndTime] = useState(
    moment(single_shift.end_datetime).format("HH:mm")
  );
  const [start_time, setStartTime] = useState(
    moment(single_shift.start_datetime).format("HH:mm")
  );

  const setMaxOrdersForShift = (max) => {
    setShift({
      ...shift,
      desired_carriers: max,
    });
  };

  useEffect(() => {
    var d = moment(date);
    let starting_date = d
      .set("hour", start_time.split(":")[0])
      .set("minutes", start_time.split(":")[1])
      .format("YYYY-MM-D HH:MM:ss");
    // d.set({
    //   h: start_time.split(":")[0],
    //   m: start_time.split(":")[1],
    // });
    let ending_date = d
      .set("hour", end_time.split(":")[0])
      .set("minutes", end_time.split(":")[1])
      .format("YYYY-MM-D HH:MM:ss");

    setShift({
      ...shift,
      start_datetime: starting_date,
      end_datetime: ending_date,
    });
  }, [start_time, end_time]);

  useEffect(() => {
    if (!_.isEqual(shift, single_shift)) updateShift(shift);
  }, [
    start_time,
    end_time,
    shift.is_recieving_new_orders,
    shift.desired_carriers,
  ]);

  const deleteCourier = (driver) => {
    dispatch(
      unRegisterCarrierShift({ shiftId: single_shift.id, carrierId: driver.id })
    );
  };

  return (
    <div>
      <div className="shift-card">
        <div className="d-flex justify-content-between">
          <div className="shift-header">
            <p>
              {shift.name}{" "}
              <span className="shift-order-len">
                ({shift.shipments_count} orders)
              </span>
            </p>
          </div>
          <p className="continue">SAVE</p>
        </div>
        <p className="my-2">Duration</p>

        <div className="duration d-flex justify-content-between">
          <p>from</p>
          {/* <TimePicker
                        onChange={() => {}}
                        defaultOpenValue={moment(shift.start_datetime).format(
                          "HH:mm:ss"
                        )}
                        size="small"
                        className=""
                      /> */}

          <input
            type={"time"}
            value={start_time}
            onChange={(e) => setStartTime(e.target.value)}
          />
        </div>
        <div className="duration d-flex justify-content-between">
          <p>to</p>
          <input
            type={"time"}
            value={end_time}
            onChange={(e) => setEndTime(e.target.value)}
          />
        </div>
        <div className="couriers mt-2">
          <div className="title">
            <p className="dark">courier</p>
            <p className="light">current/max</p>
          </div>
          <div className="inputs d-flex justify-content-between">
            <p className="curr">{single_shift.registered_carriers?.length}</p> /
            <input
              type={"number"}
              value={shift.desired_carriers}
              onChange={(e) => setMaxOrdersForShift(e.target.value)}
            />
          </div>
          <div className="empty"></div>
        </div>
        <div className="drivers ">
          {single_shift.registered_carriers?.map((driver) => {
            return (
              <div className="title d-flex justify-content-between">
                <p className="dark">
                  {driver.delivery_user.first_name}{" "}
                  {driver.delivery_user.last_name}
                </p>
                <p
                  className="light cursor-pointer"
                  onClick={() => deleteCourier(driver)}
                >
                  delete
                </p>
              </div>
            );
          })}
        </div>

        <div className="actions">
          <div className="allow">
            <Checkbox
              title=""
              name="rating-checkbox"
              disabled={true}
              checked={shift.is_recieving_new_orders}
            />
            Allow real-time join
          </div>
          {shift.shipments_count > 0 && shift.is_recieving_new_orders && (
            <>
              <p className="status">Shift is receving new orders</p>
              <button className="on">Stop Recieving Orders</button>
            </>
          )}
          {!(shift.shipments_count > 0) && (
            <>
              <p className="status">Shift has no orders</p>
              <button className="del">Delete</button>
            </>
          )}
          {shift.shipments_count > 0 && !shift.is_recieving_new_orders && (
            <>
              <p className="status">Shift is not receving new orders</p>
              <button className="off">Continue Recieving Orders</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
